<template>
  <RouterView/>
</template>

<script setup>
import {RouterView} from 'vue-router'
import {onBeforeMount} from 'vue'
import {settings} from "./appType/settings.js";

import { useStore } from 'vuex'
const vuexStore = useStore()

vuexStore.dispatch('refreshAuthInfo')

onBeforeMount(() => {
  const envName = settings.env.VUE_APP_ENV_NAME
  document.documentElement.setAttribute('owner', envName)

  if (envName) {
    document.title = envName[0].toUpperCase() + envName.slice(1)

    if (envName === 'stater' || envName === 'prima' || envName === 'arvand') {
      const link = document.querySelector("link[rel~='icon']");
      if (link) {
        if (envName === 'stater') {
          link.href = "/stater-favicon.svg"
        }
        if (envName === 'prima') {
          link.href = "/prima-favicon.png"
        }
        if (envName === 'arvand') {
          link.href = "/arvand-favicon.svg"
        }
      }
    }
  }
})
</script>

<style scoped>

</style>
